import { type ComponentProps } from 'react';

import { cx } from '@/lib/cx';

/** Forma do conteúdo que vem aí — no lugar de spinner, para a tela não "pular". */
export function Skeleton({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      aria-hidden
      className={cx(
        'animate-brilho rounded-controle bg-[linear-gradient(90deg,var(--superficie-afundada)_25%,var(--superficie-hover)_50%,var(--superficie-afundada)_75%)] bg-size-[200%_100%]',
        className,
      )}
      {...props}
    />
  );
}
